import React, { useState, useEffect, useMemo } from 'react';
import MainModal from 'components/ModalMain';
import Button from 'components/Button';
import Dropdown from 'components/Dropdown';
import ModalStaffInformation from 'screens/ModalStaffInformation';
import { useQuery } from '@apollo/client';
import { GET_ALL_USER_ROLES } from 'graphql/service';
import colors from 'constants/colors';
import { Container, Footer, Head } from './styles';
import { debouncedErrorMessage } from 'utils/messageUtil';

const ModalAddNewStaff  = ({
  hidden,
  disabled,
  buttonLabel="",
  buttonStyle,
  setStaffs
}) => {

  const [isOpen, setIsOpen] = useState(false)
  const [staffInfoIsOpen, setStaffInfoIsOpen] = useState(false)

  const [chosenRole, setChosenRole] = useState("")

  const {data, error} = useQuery(GET_ALL_USER_ROLES)

  const options = useMemo(() => {
    if (!data?.validUserRoles?.length) return [];

    return data.validUserRoles.map((role) => ({
      label: role.name,
      value: role.roleId,
    }));
  }, [data]);

  useEffect(() => {
    if (!error) return;

    if (!error.networkError) {
      let content = error.message;

      if (error.message.includes('Validation')) {
        content = JSON.stringify(
          error.graphQLErrors[0]?.extensions?.exception
        );
      }

      debouncedErrorMessage(content);
    }
  }, [error]);

  const handleContinue = () => {
    if(chosenRole === "") {
      const content = "Please select a method"
      debouncedErrorMessage(content);
    } else {
      setIsOpen(false)
      setStaffInfoIsOpen(true)
    }
  }

  return (
    <div>
      <MainModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        className="modal-success"
        buttonLabel={buttonLabel}
        buttonStyle={buttonStyle}
        hidden={hidden}
        disabled={disabled}
        additionalstyle={`
          max-width: 500px;
          .modal-content{
            min-height: 248px;
            .close {
              z-index: 200;
            }   
            .modal-body{
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              justify-content: space-between;
              padding: 16px;
              height: 100%;
            }
          }
          background: ${colors.black5};
          top: 179px;
        `}
      >
        <Container>
          <Head>Add New Staff</Head>
          <div className='text'>
            <div>Select the Role you want to add</div>
          </div>
          <Dropdown
            mainPage
            options={options}
            value={options.find((option) => option.value === chosenRole)?.label || "- Select -"}
            onChange={(e) => {
              setChosenRole(e)
            }}
          />
        </Container>
        <Footer>
          <div className='buttonContainer'>
            <Button
              success
              additionalstyle={`
                width: 100px;
              `}
              onClick={handleContinue}
            >
              Continue
            </Button>
          </div>
        </Footer>
      </MainModal>
      <ModalStaffInformation
        isOpen={staffInfoIsOpen}
        setIsOpen={setStaffInfoIsOpen}
        role={options.find((option) => option.value === chosenRole)?.label || ""}
        roleId={chosenRole}
        setStaffs={setStaffs}
      />
    </div>
  );
}

export default ModalAddNewStaff;
